.back {
  height: 100%;

  svg {
    flex: 0 0 auto;
    width: 2.375rem;
    height: 2.375rem;
    margin: 0 0.0625rem 0.0625rem 0;
    color: var(--neutral-500);
    stroke-width: 1;
  }

  .backButton {
    margin: 0 0 0 -0.5rem;

    @media (min-width: 400px) {
      margin: 0 0 0 -0.75rem;
    }

    @media (min-width: 1025px) {
      margin: 0 0 -0.4375rem;
    }

    .logoImage {
      width: 11rem;
      padding: 0.625rem;
      border-radius: 1rem;

      @media (min-width: 1025px) {
        height: 3rem;
        padding: 0.375rem 0.5rem 0.5rem;
      }
    }

    .everything {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0.5rem 1.5rem 0.5rem 0;

      @media (min-width: 1025px) {
        padding: 0.1875rem 1.5rem 0.25rem 0;
      }
    }

    .user {
      display: flex;
      align-items: center;
      min-width: 0;
      padding: 0.75rem 1.25rem 0.75rem 0;

      .userImage {
        flex: 0 0 auto;
        width: 1.5rem;
        height: 1.5rem;
        margin: 0 0.5rem 0 0;
      }
    }
  }
}
